import { Observable } from "rxjs";
import { GeneralService } from "./GeneralService";

export class CompositionService {
  static getCompositions(
    offset: number,
    limit: number,
    setLoading: (loading: boolean) => void,
    apiKey?: string
  ): Observable<any> {
    return GeneralService.get(
      `/compositions?offset=${offset}&limit=${limit}`,
      setLoading,
      JSON,
      GeneralService.PROD_ENDPOINT,
      apiKey
    );
  }

  static getComposition(
    id: string,
    setLoading: (loading: boolean) => void,
    apiKey?: string
  ): Observable<any> {
    return GeneralService.get(
      `/compositions/${id}`,
      setLoading,
      JSON,
      GeneralService.PROD_ENDPOINT,
      apiKey
    );
  }

  static getCompositionVersions(
    id: string,
    setLoading: (loading: boolean) => void,
    apiKey?: string
  ): Observable<any> {
    return GeneralService.get(
      `/compositions/${id}/versions`,
      setLoading,
      JSON,
      GeneralService.PROD_ENDPOINT,
      apiKey
    );
  }

  static createComposition(
    payload: any,
    setLoading: (loading: boolean) => void,
    apiKey?: string
  ): Observable<any> {
    return GeneralService.post(
      "/compositions",
      JSON.stringify(payload),
      setLoading,
      JSON,
      GeneralService.PROD_ENDPOINT,
      apiKey
    );
  }

  static updateComposition(
    id: string,
    payload: any,
    setLoading: (loading: boolean) => void,
    apiKey?: string
  ): Observable<any> {
    return GeneralService.put(
      `/compositions/${id}`,
      JSON.stringify(payload),
      setLoading,
      JSON,
      GeneralService.PROD_ENDPOINT,
      apiKey
    );
  }

  static deleteComposition(
    id: string,
    setLoading: (loading: boolean) => void,
    apiKey?: string
  ): Observable<any> {
    return GeneralService.delete(
      `/compositions/${id}`,
      "",
      setLoading,
      JSON,
      GeneralService.PROD_ENDPOINT,
      apiKey
    );
  }

  static getCompositionsByIntentGroup(
    intentGroupId: number,
    offset: number,
    limit: number,
    setLoading: (loading: boolean) => void,
    apiKey?: string
  ): Observable<any> {
    return GeneralService.get(
      `/compositions/intent_group/${intentGroupId}?offset=${offset}&limit=${limit}`,
      setLoading,
      JSON,
      GeneralService.PROD_ENDPOINT,
      apiKey
    );
  }

  static getCompositionsByApplicationIntent(
    applicationId: number,
    intentId: number,
    offset: number,
    limit: number,
    setLoading: (loading: boolean) => void,
    apiKey?: string
  ): Observable<any> {
    return GeneralService.get(
      `/compositions/application/${applicationId}/intent/${intentId}?offset=${offset}&limit=${limit}`,
      setLoading,
      JSON,
      GeneralService.PROD_ENDPOINT,
      apiKey
    );
  }
} 